var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { App, LoadingController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { CommonProvider } from '../../providers/common/common';
var ApiProvider = /** @class */ (function () {
    function ApiProvider(app, http, loadingCtrl, storage, comProv) {
        this.app = app;
        this.http = http;
        this.loadingCtrl = loadingCtrl;
        this.storage = storage;
        this.comProv = comProv;
        this.is_loader = false;
    }
    ApiProvider.prototype.get = function (url, params) {
        if (params === void 0) { params = null; }
        var token = localStorage.getItem('token');
        var options = {
            params: new HttpParams({ fromObject: params })
        };
        if (token && !this.comProv.isPc()) {
            options['headers'] = { 'Authorization': 'Bearer ' + token };
        }
        return this.http.get(url, options).timeout(20000).toPromise();
    };
    ApiProvider.prototype.post = function (url, params, raw) {
        if (params === void 0) { params = null; }
        if (raw === void 0) { raw = null; }
        var body;
        if (params) {
            body = new HttpParams({ fromObject: params });
        }
        else if (raw) {
            body = raw;
        }
        var token = localStorage.getItem('token');
        if (token) {
            var options = {
                headers: { 'Authorization': 'Bearer ' + token }
            };
            return this.http.post(url, body, options).timeout(20000).toPromise();
        }
        return this.http.post(url, body).timeout(20000).toPromise();
    };
    ApiProvider.prototype.patch = function (url, params) {
        if (params === void 0) { params = null; }
        var body = new HttpParams({ fromObject: params });
        var token = localStorage.getItem('token');
        if (token) {
            var options = {
                headers: { 'Authorization': 'Bearer ' + token }
            };
            return this.http.patch(url, body, options).timeout(20000).toPromise();
        }
        return this.http.patch(url, body).timeout(20000).toPromise();
    };
    ApiProvider.prototype.delete = function (url, params) {
        if (params === void 0) { params = null; }
        var token = localStorage.getItem('token');
        var options = {
            params: new HttpParams({ fromObject: params })
        };
        if (token) {
            options['headers'] = { 'Authorization': 'Bearer ' + token };
        }
        return this.http.delete(url, options).timeout(20000).toPromise();
    };
    ApiProvider.prototype.detaError = function (data) {
        var message = data['statusCode'] + ':' + data['message'];
        this.comProv.dispAlert(message);
    };
    ApiProvider.prototype.statusError = function (error, navCtrl, is_return) {
        if (is_return === void 0) { is_return = false; }
        console.log('error', error);
        var message = this.getErrorMessage(error, 'エラーが発生しました。');
        if (error['status'] == 401) {
            // 認証切れ
            this.getToken();
            //localStorage.removeItem('token');
            //this.comProv.reload();
        }
        else if (error['status'] == 500 || error['status'] == 503) {
            // サービスが提供できない
            navCtrl.setRoot('ErrorPage', { message: message });
        }
        else {
            if (is_return) {
                return message;
            }
            else {
                this.comProv.dispAlert(message);
            }
        }
    };
    ApiProvider.prototype.getErrorMessage = function (error, defult_text) {
        var message;
        if (!error['status']) {
            message = '通信状態が安定しておりません。';
        }
        else if (error['status'] >= 500 && error['status'] < 600) {
            // 500系エラー
            message = '現在ご利用いただけません。しばらくしてからもう一度お試しください。';
        }
        else {
            if (error['error']) {
                if (error['error']['message']) {
                    message = error['error']['message'];
                }
                else {
                    if (error['error']['errors']) {
                        var errors = error['error']['errors'];
                        message = '';
                        for (var key in errors) {
                            message += errors[key] + '　';
                        }
                    }
                }
            }
            if (!message) {
                message = '（' + error['status'] + '）' + defult_text;
            }
        }
        return message;
    };
    ApiProvider.prototype.getToken = function () {
        var _this = this;
        if (this.comProv.isPc()) {
            return;
        }
        var service_data = this.comProv.getService();
        this.storage.get('uid').then(function (val) {
            if (!val || val == '' || val == 'null') {
                if (_this.comProv.isApp()) {
                    _this.comProv.dispAlert('アプリを再起動してください。');
                }
                else {
                    _this.comProv.logout();
                    _this.comProv.restart();
                }
                return;
            }
            var user_env = [];
            user_env['uid'] = val;
            _this.comProv.setUserEnv(user_env);
            _this.dispLoader();
            _this.post(service_data['_links']['user_authenticate']['href'], user_env)
                .then(function (data) {
                _this.removeLoader();
                if (data['statusCode'] != '000') {
                    return;
                }
                _this.comProv.setUser(data['data']);
                localStorage.setItem('token', data['token']);
                _this.comProv.reload();
                //navCtrl.setRoot('home');
            }).catch(function (error) {
                _this.removeLoader();
            });
        });
    };
    ApiProvider.prototype.dispLoader = function () {
        if (this.is_loader) {
            return;
        }
        this.is_loader = true;
        this.loader = this.loadingCtrl.create({
            spinner: "dots",
            showBackdrop: false,
            duration: 20000,
            cssClass: 'loader_common'
        });
        this.loader.present();
    };
    ApiProvider.prototype.removeLoader = function () {
        if (!this.is_loader || !this.loader) {
            return;
        }
        this.is_loader = false;
        try {
            this.loader.dismiss();
            this.loader = null;
        }
        catch (e) {
            console.log(e);
        }
    };
    ApiProvider.prototype.getExternal = function (url, params) {
        if (params === void 0) { params = null; }
        var options = {
            params: new HttpParams({ fromObject: params })
        };
        return this.http.get(url, options).timeout(20000).toPromise();
    };
    ApiProvider.prototype.postExternal = function (url, params) {
        if (params === void 0) { params = null; }
        if (params) {
            for (var key in params) {
                params[key] = encodeURIComponent(params[key]);
            }
        }
        console.log('params', params);
        var body = new HttpParams({ fromObject: params });
        return this.http.post(url, body).timeout(20000).toPromise();
    };
    ApiProvider.prototype.statusErrorExternal = function (error, key_names, page) {
        if (key_names === void 0) { key_names = null; }
        if (page === void 0) { page = ''; }
        var message = '';
        if (!error['status']) {
            // レスポンスなし
            message = '連携システムの通信状態が安定しておりません。';
        }
        else if (error['status'] == 401) {
            // 認証切れ
            /*let external_data = this.comProv.getExternalData();
            external_data['access_token'] = null;
            localStorage.setItem('external_data', JSON.stringify(external_data));*/
            message = '連携システムとの認証が必要です。';
        }
        else if (error['status'] >= 500 && error['status'] < 600) {
            // 500系エラー
            message = '現在連携システムがご利用いただけません。しばらくしてからもう一度お試しください。';
        }
        else if (error['error']) {
            if (error['error']['message']) {
                message = error['error']['message'];
            }
            else if (error['error']['errors']) {
                var errors = error['error']['errors'];
                for (var key in errors) {
                    if (key_names) {
                        if (key_names[key]) {
                            message += key_names[key] + '：';
                        }
                    }
                    message += errors[key] + '<br />';
                }
            }
        }
        if (!message) {
            message = '（' + error['status'] + '）' + '連携システムにエラーが発生しました。';
        }
        this.comProv.dispAlert(message);
        var exception = '';
        if (error['error']) {
            if (error['error']['exception']) {
                exception = error['error']['exception'];
            }
        }
        this.comProv.sendLog({ 'name': page, 'result': 'ng', 'status': error['status'], 'exception': exception });
    };
    ApiProvider.prototype.getFeed = function (url, params, is_token) {
        if (params === void 0) { params = null; }
        if (is_token === void 0) { is_token = null; }
        var options = { params: new HttpParams({ fromObject: params }) };
        options['responseType'] = 'text';
        if (is_token) {
            var rss_token = this.comProv.getOptionsValue('rss_token');
            options['headers'] = { 'Authorization': 'Bearer ' + rss_token };
        }
        return this.http.get(url, options).timeout(20000).toPromise();
    };
    ApiProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [App,
            HttpClient,
            LoadingController,
            Storage,
            CommonProvider])
    ], ApiProvider);
    return ApiProvider;
}());
export { ApiProvider };
//# sourceMappingURL=api.js.map


// WEBPACK FOOTER //
// ./src/providers/api/api.ts.pre-build-optimizer.js